<template>
  <v-container fluid fill-height>
    <v-container fluid>
      <v-layout column align-center style="width: 50%; margin: auto;">
        <intro />
        <icon-bar />
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import Intro from '@/components/home/Intro.vue';
import IconBar from '@/components/home/IconBar.vue';

export default {
  components: {
    'intro': Intro,
    'icon-bar': IconBar,
  },
};
</script>

<style>
.subheading.home {
   max-width: 600px;
}
</style>
